export const visibilityOptions = [
    {
        key: 'both',
        name: 'Both mobile and desktop'
    },
    {
        key: 'mobile',
        name: 'Mobile only'
    },
    {
        key: 'desktop',
        name: 'Desktop only'
    }
];
